export default "__VITE_ASSET__61da9e25__"